import React, { useState } from "react";
import { IResponseQuestionnaire, IResultIMC } from "../../../../../interfaces/enum/GestaoDeCronicosEnum";
import {
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  FormLabel,
} from "@mui/material";
import DefaultButton from "../../../../../components/Accessibility/DefaultButton";
import { useFormik } from "formik";
import "../../styles.css";
import { postSalvarRespQuestCronicos } from "../../../../../services/SaudeBemEstar/GestaoDeCronicosService";
import EncerramentoModal from "./componentes/EncerramentoModal";
import { useGestaoDeCronicosCaptacao } from "../../context/CaptacaoContext";
import LoadingApp from "../../../../../components/LoadingApp";

type FormValues = {
  [key: string]: string;
};

export const QuestionarioQuestoes = () => {
  const [response, setResponse] = useState<IResultIMC>();
  const [loading, setLoading] = useState<boolean>(false);
  const [showEncerramentoModal, setShowEncerramentoModal] =
    useState<boolean>(false);
  const { responseQuestionnaire } = useGestaoDeCronicosCaptacao();

  const formik = useFormik({
    initialValues: responseQuestionnaire
      ? responseQuestionnaire?.listaQuestoesCronicos.reduce(
          (acc, question) => ({
            ...acc,
            [question.idQuestaoTeleOrient]: "",
          }),
          {} as FormValues
        )
      : {},
    onSubmit: (values) => {
      setLoading(true);
      let data = {} as IResponseQuestionnaire["listaQuestoesCronicos"];
      if (responseQuestionnaire) {
        data = responseQuestionnaire?.listaQuestoesCronicos.map((questao) => ({
          ...questao,
          codTipoTeleOrientacao: questao.codTipoTeleOrient,
          resposta: (values as Record<string, any>)[
            questao.idQuestaoTeleOrient
          ],
        }));
      }

      postSalvarRespQuestCronicos(data)
        .then((res: any) => {
          if (res !== null && res !== undefined) {
            setResponse(res)
            setShowEncerramentoModal(true);
          }
        })
        .catch((error) => {
          console.error("Erro ao salvar IMC:", error);
        })
        .finally(() => setLoading(false));
      formik.resetForm();
    },
  });

  const allAnswered = Object.values(formik.values).every((value) => value);

  return (
    <div className="content-container">
      <LoadingApp showLoading={loading} />

      {!loading && (
        <>
          <form onSubmit={formik.handleSubmit}>
            {responseQuestionnaire?.listaQuestoesCronicos.map((question) => (
              <FormControl
                key={question.idQuestaoTeleOrient}
                component="fieldset"
                style={{ marginBottom: "1rem", display: "flex" }}
              >
                <FormLabel
                  component="legend"
                  style={{ marginBottom: "0.5rem", color: "inherit" }}
                >
                  {question.txtQuestao}
                </FormLabel>
                <RadioGroup
                  name={question.idQuestaoTeleOrient}
                  value={formik.values[question.idQuestaoTeleOrient]}
                  onChange={formik.handleChange}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  {question.lstQuestoesTriagem.map((option) => (
                    <FormControlLabel
                      key={option.idItemQuestaoTeleOrient}
                      value={option.vlrItem}
                      control={<Radio />}
                      label={option.txtItemQuestao}
                      style={{ flex: "1", marginRight: "1rem" }}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            ))}
            <DefaultButton
              style={{ margin: "25px 0px 25px 0px " }}
              className="button-questionnaire-detail"
              text="Continuar"
              disabled={!allAnswered}
              type="submit"
            />
          </form>
          <EncerramentoModal
            showModal={showEncerramentoModal}
            setShowEncerramentoModal={setShowEncerramentoModal}
            codAcao={response}
          />
        </>
      )}
    </div>
  );
};
